export const ACCESS_TOKEN_COOKIE_KEY = 'token'
export const GDPR_HAS_AGREED_COOKIE_KEY = 'has-agreed'
export const REFERRAL = 'referral'
export const CONFIG = 'config'
export const NEXT_LOCALE = 'NEXT_LOCALE'
